<img
  class="w-12 h-12 rounded-md object-cover cursor-pointer"
  data-testid="image-preview-image"
  [src]="src()"
  [alt]="alt()"
  (click)="selectedPhotoUrl.set(src()); photoModal.show()"
/>

<app-pan-modal #photoModal [topLevel]="modalTopLevel()">
  <div header data-testid="image-preview-modal-title">{{ modalTitle() }}</div>
  <div body class="flex justify-center items-center">
    <img data-testid="image-preview-modal-image" [src]="selectedPhotoUrl()" [alt]="alt()" />
  </div>

  <div footer class="flex gap-2">
    <ng-content [select]="footerActions"></ng-content>
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
